const KEYS = {
  clientId: 'smn.clientId',
  muted: 'smn.muted',
} as const;

function read(store: Storage_, key: string): string | null {
  try {
    return store().getItem(key);
  } catch {
    return null;
  }
}

function write(store: Storage_, key: string, value: string): void {
  try {
    store().setItem(key, value);
  } catch {
  }
}

type Storage_ = () => Storage;
const local: Storage_ = () => localStorage;
const session: Storage_ = () => sessionStorage;

export function getClientId(): string {
  const existing = read(session, KEYS.clientId);
  if (existing && existing.length > 0) return existing;
  const fresh = crypto.randomUUID();
  write(session, KEYS.clientId, fresh);
  return fresh;
}

export function getMuted(): boolean {
  return read(local, KEYS.muted) === '1';
}

export function setMuted(muted: boolean): void {
  write(local, KEYS.muted, muted ? '1' : '0');
}

